export const iconFontAwesomeReligionChurch = (
	<i className="fa-solid fa-church"></i>
);
